import * as React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/Elements';
import { ultraWideModalStyles } from '@/components/Elements/Modal/customStyles';
import { PaymentsModal } from '@/components/Elements/PaymentsModal';

export type IncompletePaymentMethodFailedErrorModalProps = {
  onConfirmAction: () => void;
  onCancelAction: () => void;
  isOpen?: boolean;
};

export const IncompletePaymentMethodFailedErrorModal = ({
  onConfirmAction,
  onCancelAction,
  isOpen = false,
}: IncompletePaymentMethodFailedErrorModalProps) => {
  const [disabledButtons, setDisabledButtons] = useState(false);
  const { t } = useTranslation();

  const onDefaultConfirmAction = () => {
    setDisabledButtons(true);
    onConfirmAction && onConfirmAction();
  };

  const onDefaultCancelAction = () => {
    setDisabledButtons(true);
    onCancelAction && onCancelAction();
  };

  const getCancelButton = () => (
    <Button
      variant="ghost"
      type="button"
      onClick={onDefaultCancelAction}
      size="md"
      className="!mx-3.5 !w-1/2"
      disabled={disabledButtons}
    >
      {t('IncompletePaymentMethodFailedErrorModal.cancelButton')}
    </Button>
  );

  const getConfirmButton = () => (
    <Button
      variant="primary"
      type="button"
      onClick={onDefaultConfirmAction}
      size="md"
      className="!w-1/2"
      disabled={disabledButtons}
    >
      {t('IncompletePaymentMethodFailedErrorModal.confirmButton')}
    </Button>
  );

  return (
    <PaymentsModal
      closeButton={true}
      isOpen={isOpen}
      style={ultraWideModalStyles}
      shouldCloseOnOverlayClick={false}
      onRequestClose={onDefaultCancelAction}
    >
      <div className="w-full h-full text-left pl-8">
        <div className="text-2xl text-black font-black">
          {t('IncompletePaymentMethodFailedErrorModal.title')}
        </div>
        <div className="text-lg">{t('IncompletePaymentMethodFailedErrorModal.description')}</div>
        <div className="ml-5 mb-12 text-lg">
          <ul className="list-disc">
            <li key="1" className="font-semibold">
              {t('IncompletePaymentMethodFailedErrorModal.description_1')}
            </li>
            <li key="2" className="font-semibold">
              {t('IncompletePaymentMethodFailedErrorModal.description_2')}
            </li>
          </ul>
        </div>
        <div className="mb-12 text-lg">
          {t('IncompletePaymentMethodFailedErrorModal.description_end')}
        </div>
        <div className="mb-4 flex items-center justify-end w-full">
          {getCancelButton()}
          {getConfirmButton()}
        </div>
        <div className="mb-3 flex items-left mb-10 lg:mb-0 w-full">
          {t('IncompletePaymentMethodFailedErrorModal.disclaimer')}
        </div>
      </div>
    </PaymentsModal>
  );
};
